export default __webpack_public_path__ + "static/media/working2.57045763.png";